export const infoBookings = {
    image:'bg-amigos',
    name:'LA DORADA - CALDAS / BARRIO CENTRO',
    description:'¡Descubre Kolozo, donde la gastronomía global se une a la mixología creativa en un ambiente premium con vistas al río Magdalena! Experimenta sabores únicos inspirados en culturas mexicana y mediterránea, galardonados con el premio a la Mejor Hamburguesa de La Dorada 2022. ¡Reserva ahora y vive una experiencia inigualable de comida, cócteles y música en Kolozo!',
    pathMenu: 'http://wa.me/573136582723#',
    titleButton: 'RESERVA AQUÍ →'
}